export const SHOW_CUSTOMER_DETAILS = "SHOW_CUSTOMER_DETAILS";

export const SHOW_LEFT_SIDE_IN_CONTACT_PAGE = "SHOW_LEFT_SIDE_IN_CONTACT_PAGE";

export const SHOW_RIGHT_SIDE_IN_CHAT = "SHOW_RIGHT_SIDE_IN_CHAT";

export const SHOW_SEARCH_BAR = "SHOW_SEARCH_BAR";

export const SHOW_MESSAGE_INFO_BAR = "SHOW_MESSAGE_INFO_BAR";

export const SHOW_CREATE_NEW_GROUP_BAR = "SHOW_CREATE_NEW_GROUP_BAR";

export const SHOW_SUGGESTED_GROUPS_BAR = "SHOW_SUGGESTED_GROUPS_BAR";

export const SHOW_MEDIA_BAR = "SHOW_MEDIA_BAR";

export const SHOW_STARRED_MESSAGES_BAR = "SHOW_STARRED_MESSAGES_BAR";

export const SHOW_PHOTO_MODAL = "SHOW_PHOTO_MODAL";
